import GenericTopPostsDrawer from './GenericTopPostsDrawer';
import React from 'react';
import { getCategoryRelatedHashtagTopPosts } from 'utils/api/instagram.api';

const RelatedHashtagCategoryDrawer = ({
    year,
    week,
    categories,
    hashtags,
    countries,
    name,
    displayQty,
}) => {
    const queryParams = {
        category: categories || null,
        hashtag: hashtags || null,
        country: countries || null,
        page: 1,
        per_page: 500,
    };

    return (
        <GenericTopPostsDrawer
            year={year}
            week={week}
            name={name}
            displayQty={displayQty}
            queryFn={getCategoryRelatedHashtagTopPosts}
            queryParams={queryParams}
        />
    );
};

export default RelatedHashtagCategoryDrawer;
